import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardSearchParams} from '../../types'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {useMemo} from 'react'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {formatNumber} from '@/utilities/helpers'

export const DashboardPatientAbsencesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({
        fields: ['patientAbsences'],
        ...searchParams
    })
    const total = useMemo(
        () => (data?.patientAbsences?.paid ?? 0) + (data?.patientAbsences?.not_paid ?? 0),
        [data?.patientAbsences]
    )

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:patient_absences')} />
    }

    return (
        <DashboardCard title={t('dashboard:patient_absences')}>
            <Flexbox direction="column" gap={4}>
                <Grid columns={2} gap={2}>
                    <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                        {formatNumber(total)}
                    </Text>
                </Grid>

                <ul>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatNumber(data?.patientAbsences?.paid ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:reimbursed_absences')}
                            </Text>
                        </Flexbox>
                    </li>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatNumber(data?.patientAbsences?.not_paid ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:not_reimbursed_absences')}
                            </Text>
                        </Flexbox>
                    </li>
                </ul>
            </Flexbox>
        </DashboardCard>
    )
}
